import React, { memo } from "react";
import { toTitleCase } from "../../../utils/index";

function NutrientTable({
    title,
    productItems,
    double,
    splitValues,
    unit,
    showUnit,
    takeFirstValue,
    removeUnitFromName,
    showBothValues,
    headings,
    aminoAcids,
}) {
    //const isSelectedRow = row => row === 'Energy' || row === 'Protein';

    const getVal = (nutrient, val) => {
        let returnVal = "";
        (nutrient || []).forEach((_val) => {
            if (_val.name === val) {
                returnVal = _val.value;
            }
        });
        return returnVal;
    };

    const safeHeadings = Array.isArray(headings) ? headings : [];

    const getRowKey = (nutrient, index) => {
        const nutrientName = getVal(nutrient, "nutrientName") || "";
        const nutrientUnit = getVal(nutrient, "nutrientUnit") || "";
        return `${index}-${nutrientName}-${nutrientUnit}`;
    };

    const getFormattedAmount = (nutrient) => {
        const nutrientAmount = getVal(nutrient, "nutrientAmount");
        if (nutrientAmount === "" || nutrientAmount == null) {
            return "--";
        }

        if (Number.isNaN(+nutrientAmount)) {
            return nutrientAmount;
        }

        if (+nutrientAmount < 1) {
            return +Number.parseFloat(nutrientAmount).toFixed(3);
        }

        if (+nutrientAmount < 10) {
            return +Number.parseFloat(nutrientAmount).toFixed(2);
        }

        return +Number.parseFloat(nutrientAmount).toFixed(1);
    };

    const getDisplayName = (nutrient) => {
        const name = getVal(nutrient, "nutrientName");
        const unit = getVal(nutrient, "nutrientUnit");
        let displayName;

        if (unit === "percent" && name.toLowerCase().endsWith(" en%")) {
            // Old format: "protein en%" → "Protein"
            displayName = name.slice(0, -4);
        } else if (
            unit &&
            name.toLowerCase().endsWith(` ${unit.toLowerCase()}`)
        ) {
            // Old format: name ends with " unit" → strip it
            displayName = name.slice(0, -(unit.length + 1));
        } else {
            // New format or no embedded unit → use as-is
            displayName = name;
        }

        return showUnit && unit ? `${displayName} (${unit})` : displayName;
    };

    return productItems && productItems.length > 0 ? (
        <div>
            {!showBothValues && !aminoAcids && (
                <div className="c-nutrient-table">
                    <ul
                        className={
                            "c-product__list--nutrition" +
                            (double ? " c-product__list--double" : "")
                        }
                    >
                        {productItems?.map((nutrient, index) => {
                            const nutrientAmount = getVal(
                                nutrient,
                                "nutrientAmount",
                            );

                            if (nutrientAmount === "-,-") {
                                return null;
                            }

                            return (
                                <li key={getRowKey(nutrient, index)}>
                                    <div>
                                        {aminoAcids ? (
                                            <span>{`${getVal(nutrient, "nutrientName")} (${getVal(nutrient, "nutrientUnit")})`}</span>
                                        ) : (
                                            <span>
                                                {toTitleCase(
                                                    getDisplayName(nutrient),
                                                )}
                                            </span>
                                        )}
                                    </div>
                                    <div>{getFormattedAmount(nutrient)}</div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
            {showBothValues && !aminoAcids && (
                <div className="c-nutrient-table">
                    <ul
                        className={
                            "c-product__list--nutrition" +
                            (double ? " c-product__list--double" : "")
                        }
                    >
                        {productItems?.map((nutrient, index) => (
                            <React.Fragment key={getRowKey(nutrient, index)}>
                                <li key={`n-${index}`}>
                                    <div>
                                        <span className="c-nutrient-table__item-heading">
                                            {toTitleCase(
                                                getDisplayName(nutrient),
                                            )}
                                        </span>
                                    </div>
                                    <div>
                                        <span className="c-nutrient-table__item-heading">
                                            {toTitleCase(safeHeadings[0] || "")}
                                        </span>
                                    </div>
                                    <div>
                                        {
                                            getVal(
                                                nutrient,
                                                "nutrientAmount",
                                            ).split(",")[0]
                                        }
                                    </div>
                                </li>
                                {safeHeadings.length > 1 &&
                                getVal(nutrient, "nutrientAmount").split(
                                    ",",
                                )[1] !== "-" ? (
                                    <li key={`n-${index}b`}>
                                        <div>
                                            <span className="c-nutrient-table__item-heading">
                                                {toTitleCase(
                                                    getDisplayName(nutrient),
                                                )}
                                            </span>
                                        </div>{" "}
                                        <div>
                                            <span className="c-nutrient-table__item-heading">
                                                {toTitleCase(
                                                    safeHeadings[1] || "",
                                                )}
                                            </span>
                                        </div>
                                        <div>
                                            {
                                                getVal(
                                                    nutrient,
                                                    "nutrientAmount",
                                                ).split(",")[1]
                                            }
                                        </div>
                                    </li>
                                ) : safeHeadings.length > 1 ? (
                                    <li key={`n-${index}c`}>
                                        <div>
                                            <span className="c-nutrient-table__item-heading">
                                                {toTitleCase(
                                                    getDisplayName(nutrient),
                                                )}
                                            </span>
                                        </div>
                                        <div>
                                            <span className="c-nutrient-table__item-heading">
                                                {toTitleCase(
                                                    safeHeadings[1] || "",
                                                )}
                                            </span>
                                        </div>
                                        <div>--</div>
                                    </li>
                                ) : (
                                    <li className="ut-remove-border"></li>
                                )}
                            </React.Fragment>
                        ))}
                    </ul>
                </div>
            )}
            {aminoAcids && (
                <div className="c-nutrient-table">
                    <ul
                        className={
                            "c-product__list--nutrition" +
                            (double ? " c-product__list--double" : "")
                        }
                    >
                        {productItems?.map((nutrient, index) => {
                            const nutrientAmount = getVal(
                                nutrient,
                                "nutrientAmount",
                            );

                            if (
                                nutrientAmount.split(",")[0] === "-,-" ||
                                nutrientAmount.split(",")[0] === "-"
                            ) {
                                return null;
                            }

                            return (
                                <React.Fragment
                                    key={getRowKey(nutrient, index)}
                                >
                                    <li key={`n-${index}`}>
                                        <div>
                                            <span className="c-nutrient-table__item-heading">{`${getVal(nutrient, "nutrientName")} (${getVal(nutrient, "nutrientUnit")})`}</span>
                                        </div>
                                        <div>
                                            <span className="c-nutrient-table__item-heading">
                                                {toTitleCase(
                                                    safeHeadings[0] || "",
                                                )}
                                            </span>
                                        </div>
                                        <div>
                                            {
                                                getVal(
                                                    nutrient,
                                                    "nutrientAmount",
                                                ).split(",")[0]
                                            }
                                        </div>
                                    </li>
                                    {safeHeadings.length > 1 &&
                                    getVal(nutrient, "nutrientAmount").split(
                                        ",",
                                    )[1] !== "-" ? (
                                        <li key={`n-${index}b`}>
                                            <div>
                                                <span className="c-nutrient-table__item-heading">{`${getVal(nutrient, "nutrientName")} (${getVal(nutrient, "nutrientUnit")})`}</span>
                                            </div>
                                            <div>
                                                <span className="c-nutrient-table__item-heading">
                                                    {toTitleCase(
                                                        safeHeadings[1] || "",
                                                    )}
                                                </span>
                                            </div>
                                            <div>
                                                {
                                                    getVal(
                                                        nutrient,
                                                        "nutrientAmount",
                                                    ).split(",")[1]
                                                }
                                            </div>
                                        </li>
                                    ) : safeHeadings.length > 1 ? (
                                        <li key={`n-${index}c`}>
                                            <div>
                                                <span className="c-nutrient-table__item-heading">{`${getVal(nutrient, "nutrientName")} (${getVal(nutrient, "nutrientUnit")})`}</span>
                                            </div>
                                            <div>
                                                <span className="c-nutrient-table__item-heading">
                                                    {toTitleCase(
                                                        safeHeadings[1] || "",
                                                    )}
                                                </span>
                                            </div>
                                            <div>--</div>
                                        </li>
                                    ) : (
                                        <li className="ut-remove-border"></li>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    ) : null;
}

export default memo(NutrientTable);
